import { State as ListState, reducer as listReducer } from "./list";
import { State as EditState, reducer as editReducer } from "./edit";
import { State as BulkEditState, reducer as bulkEditReducer } from "./bulkEdit";

import { combineReducers } from "redux";

export interface State {
    priceLists: {
        list: ListState;
        edit: EditState;
        bulkEdit: BulkEditState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
    edit: editReducer,
    bulkEdit: bulkEditReducer,
});
